import React, { useState } from "react";
import {
  markBrandFeatured,
  markBrandUnFeatured,
} from "../../../services/brandService";
import Swal from "sweetalert2";
import { handleErrors } from "../../../utils/errorHandler";

const BrandFeaturedToggleSwitch = ({
  propId,
  initialStatus,
  onStatusChange,
}) => {
  const [isFeatured, setisFeatured] = useState(initialStatus === "Featured");

  const handleToggle = async () => {
    const newStatus = isFeatured ? "UnFeatured" : "Featured";
    const modalTitle = isFeatured
      ? "Mark Brand UnFeatured"
      : "Mark Brand Featured";
    const modalMessage = isFeatured
      ? "Are you sure you want to mark this brand unfeatured?"
      : "Are you sure you want to mark this brand featured?";

    const result = await Swal.fire({
      title: modalTitle,
      text: modalMessage,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        if (isFeatured) {
          await markBrandUnFeatured(propId, newStatus);
        } else {
          await markBrandFeatured(propId, newStatus);
        }
        setisFeatured(!isFeatured);
        onStatusChange(newStatus);

        Swal.fire(
          "Success!",
          `The brand has been ${
            newStatus === "Featured" ? "Featured" : "UnFeatured"
          }.`,
          "success"
        );
      } catch (error) {
        handleErrors(error);
      }
    }
  };

  return (
    <label className="switch">
      <div className="form-check form-switch form-switch-custom form-switch-primary">
        <input
          className="form-check-input"
          type="checkbox"
          checked={isFeatured} // Checked means user is Blocked
          onChange={handleToggle}
        />
      </div>
      <span className="slider round"></span>
    </label>
  );
};

export default BrandFeaturedToggleSwitch;
